import {CircularProgress} from '@mui/material'
import {Icon} from 'src/common/generics/components/icon/IconBase'
import LoadMoreDisabledIcon from 'src/images/load-more-icon-disabled.svg'
import LoadMoreIcon from 'src/images/load-more-icon.svg'
import {ButtonContainer, ButtonContainerInner, ButtonText} from './ButtonBase'

type ButtonProps = {
  children?: React.ReactNode
  isLoading: boolean
  minWidth?: string
  minHeight?: string
  disabled?: boolean
  onClick: () => void
}

function LoadMoreButton(props: ButtonProps) {
  const {onClick, isLoading, minHeight, minWidth, disabled = false} = props

  return (
    <ButtonContainer minWidth={minWidth || '175px'} minHeight={minHeight || '48px'}>
      {isLoading ? (
        <CircularProgress size='25px' />
      ) : (
        <ButtonContainerInner
          onClick={() => {
            if (!disabled) onClick()
          }}>
          <ButtonText disabled={disabled}>Carregar mais</ButtonText>
          <Icon src={disabled ? LoadMoreDisabledIcon : LoadMoreIcon} alt='Icone' />
        </ButtonContainerInner>
      )}
    </ButtonContainer>
  )
}

export default LoadMoreButton
